import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { CopyUtmParams } from "../copy-utm-params";

export const Taboola = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all existing campaigns. To do so,
      navigate to the bottom of each <b>New Campaign/Edit Campaign</b> page, and
      paste the copied parameters into the <b>Tracking Code</b> section. For
      more information, you can review <b>Taboola</b>&apos;s{" "}
      <GenericExternalLink href="https://help.taboola.com/hc/en-us/articles/115006030688-Creating-and-Adding-URL-Parameters-for-Tracking">
        documentation
      </GenericExternalLink>
      .
    </p>
    <CopyUtmParams className="mt-3" platform={NorthbeamUtmPlatform.TABOOLA} />
    <p className="mb-0">
      Copy the Northbeam UTM parameters text and paste it into the{" "}
      <b>Tracking code</b> input field.
    </p>
  </div>
);
